module.exports = __webpack_public_path__ + "static/media/oberflex-zebranoblancpoudre-1200x2490.4039052f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranoblancpoudre-1200x2490.jpg
// module id = 1076
// module chunks = 37